export default __webpack_public_path__ + "static/media/WAS0190.34I-36138_-21166_0.d4579b90.jpg";